import template   from './my-purchase-records.html'
import controller from './my-purchase-records.controller'
import './my-purchase-records.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-purchase-records/my-purchase-records.component.js